import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.6875 12C1.6875 14.7351 2.774 17.3581 4.70797 19.2921C6.64193 21.226 9.26496 22.3125 12 22.3125C14.7351 22.3125 17.3581 21.226 19.2921 19.2921C21.226 17.3581 22.3125 14.7351 22.3125 12C22.3125 9.26496 21.226 6.64193 19.2921 4.70797C17.3581 2.774 14.7351 1.6875 12 1.6875C9.26496 1.6875 6.64193 2.774 4.70797 4.70797C2.774 6.64193 1.6875 9.26496 1.6875 12Z",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.25 10.125H12V16.6875",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.25 16.6875H15.75",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 7.3125V5.4375",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }